import React from 'react';

// Per spec: Home tab dropped. The Clips/Play tab takes the leftmost
// slot — "the feed" IS the home on mobile now. Four-tab layout:
// Clips · Library · Create · More.

const LibraryIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
    <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
  </svg>
);

const ClipsIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="5" y="2" width="14" height="20" rx="2"/>
    <polygon points="10 9 15 12 10 15 10 9" fill="currentColor" stroke="none"/>
  </svg>
);

const MoreIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="5" cy="12" r="1.2" fill="currentColor"/>
    <circle cx="12" cy="12" r="1.2" fill="currentColor"/>
    <circle cx="19" cy="12" r="1.2" fill="currentColor"/>
  </svg>
);

const MicIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
    <line x1="12" y1="19" x2="12" y2="23"/>
    <line x1="8" y1="23" x2="16" y2="23"/>
  </svg>
);

export default function MobileBottomBar({ view, onNavigate, onCreateEpisode, onOpenMore }) {
  return (
    <nav className="mobile-bottom-bar" aria-label="Mobile navigation">

      {/* Clips/Play — the leftmost tab, replacing the old Home tab.
          On mobile this IS the home surface. */}
      <button
        className={`mbb-tab${view === 'clips' ? ' mbb-tab-active mbb-tab-gold' : ''}`}
        onClick={() => onNavigate('clips')}
        aria-label="Clips feed"
        style={view === 'clips' ? { color: 'var(--gold, #ffb101)' } : undefined}
      >
        <ClipsIcon />
        <span className="mbb-tab-label">Play</span>
      </button>

      {/* Library */}
      <button
        className={`mbb-tab${view === 'episodes' ? ' mbb-tab-active' : ''}`}
        onClick={() => onNavigate('episodes')}
        aria-label="Episode library"
      >
        <LibraryIcon />
        <span className="mbb-tab-label">Library</span>
      </button>

      {/* Create — prominent center CTA */}
      <button
        className="mbb-tab mbb-tab-create"
        onClick={onCreateEpisode}
        aria-label="Create new episode"
      >
        <span className="mbb-create-ring"><MicIcon /></span>
        <span className="mbb-tab-label">Create</span>
      </button>

      {/* More — opens nav drawer */}
      <button
        className="mbb-tab"
        onClick={onOpenMore}
        aria-label="More options"
      >
        <MoreIcon />
        <span className="mbb-tab-label">More</span>
      </button>

    </nav>
  );
}
